import { version } from '@doxyme/hotpot/react';
import { getLogger } from '../../libs/logger';

export const hotpotLogger = getLogger('hotpot', {
  package: 'hotpot',
  packageVersion: version,
});
hotpotLogger.setLevel('warn');
